import { PureComponent } from 'react';

import { Button } from 'components/Button/Button';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';

/**
 * Default EditWidget component.
 * @param  {[type]} {text    [description]
 * @param  {[type]} onClick} [description]
 * @return {[type]}          [description]
 */
export default class EditWidget extends PureComponent {
  static propTypes = {
    // columnOrientation: PropTypes.string.isRequired,
    msg: PropTypes.object.isRequired,
    onAdd: PropTypes.func.isRequired,
    onOrientationChange: PropTypes.func.isRequired,
  };

  handleAdd = handleEvent((e) => {
    e.preventDefault();
    this.props.onAdd();
  });

  handleOrientationChange = (e) => {
    const orientation = e.target.getAttribute('data-orientation');
    this.props.onOrientationChange(orientation);
  };

  render() {
    const { msg } = this.props;
    return (
      <div className='flex flex-1 justify-end text-right'>
        <Button
          variant='secondary'
          icon='fa-plus'
          type='button'
          onClick={this.handleAdd}
        >
          {get(msg, ['dazzle', 'addNewWidget'])}
        </Button>
      </div>
    );
  }
}
